import {GetSeferData} from "SeferPetach/GetData";

//#region Development Stage
export async function getDevelopmentStageList(obj) {
    const args = obj;
    var payload = await GetSeferData("gdslist", args);
    return (payload);
}
export async function getDevelopmentStageByID(obj){
    const args = {
        DevelopmentStageId: obj.DevelopmentStageId,
    };
    var payload = await GetSeferData("gds", args);
    return (payload);
}
export async function updateDevelopmentStage(obj) {
    const args = obj;
    var payload = await GetSeferData("uds", args);
    return (payload);
}
export async function updateDevelopmentStageStatus(obj) {
    const args = obj;
    var payload = await GetSeferData("udsst", args);
    return (payload);
}
export async function deleteDevelopmentStage(obj){
    const args = obj;
    var payload = await GetSeferData("dds", args);
    return (payload);
}
//#endregion

//#region Application Content
export async function getApplicationContentList(obj) {
    const args = obj;
    var payload = await GetSeferData("gaclist", args);
    return (payload);
}
export async function getApplicationContentByID(obj){
    const args = {
        AppContentId: obj.AppContentId,
    };
    var payload = await GetSeferData("gac", args);
    return (payload);
}
export async function updateApplicationContent(obj) {
    const args = obj;
    var payload = await GetSeferData("uac", args);
    return (payload);
}
export async function updateApplicationContentStatus(obj) {
    const args = obj;
    var payload = await GetSeferData("uacst", args);
    return (payload);
}
export async function deleteApplicationContent(obj){
    const args = obj;
    var payload = await GetSeferData("dac", args);
    return (payload);
}
//#endregion